import { createContext, useContext, Dispatch } from 'react';
import { IPostUIState, PostOption, PostUIStateAction } from './types';

interface IPostContext {
  state: IPostUIState;
  dispatch: Dispatch<PostUIStateAction>;
}

export const initialPostUIState: IPostUIState = {
  option: PostOption.Link,
  moderatorMode: true,
  engagePost: false,
  validUrl: false,
  pin: false,
  schedule: false,
  commentary: false,
  disclosures: false,
  tracking: false,
  share: false,
};

export const PostUIContext = createContext<IPostContext>({
  state: initialPostUIState,
  dispatch: () => null,
});

export const usePostContext = () => useContext(PostUIContext);
